export const config = {
  apiurl: process.env.REACT_APP_APIURL,
  fileurl: process.env.REACT_APP_FILEURL,
}
